var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"gritter-main-wrapper top-right",attrs:{"id":"gritter-notice-wrapper","name":"notification","tag":"div"}},_vm._l((_vm.notifications),function(item){return _c('be-notification',_vm._b({key:item.id,staticClass:"notification-item d-print-none"},'be-notification',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }